
import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})


export class HandleErrorsService {

    ErrorsMap = {
        birth_day: {
            status: "error",
            message: "Fecha de nacimiento incorrecta",
            code: 422
        },
        birth_date: {
            status: "error",
            message: "Fecha de nacimiento incorrecta",
            code: 422
        },
        phone: {
            status: "error",
            message: "Teléfono incorrecto",
            code: 422
        },
        document_number: {
            message: "Número de documento inválido",
            code: 422,
            status: "error"
        },
        document_expiration_date: {
            message: "Fecha de vencimiento incorrecta",
            code: 422,
            status: "error"
        },
        document_support: {
            message: "Número de documento inválido",
            code: 422,
            status: "error"
        },
        request_id: {
            message: "El código de solicitud es inválido",
            code: 422,
            status: "error"
        },
        generic: {
            status: "error",
            message: "Error desconocido",
            code: 0
        },
        code: {
            status: "error",
            messages: { 
                "The code must be 6 characters.": "El código debe ser de 6 dígitos",
                "The code must be 3 characters.": "El código debe ser de 3 dígitos",
            },
            code: 422
        }
    }

    constructor() {}

    public getError(flow, endpoint, number) {
        let n = '' + number;
        return this.ErrorsMap[flow] && this.ErrorsMap[flow][endpoint] && this.ErrorsMap[flow][endpoint][n] ? this.ErrorsMap[flow][endpoint][n] : this.getGenericMessage();
    }

    async getGenericMessage() {
        return this.ErrorsMap.generic;
    }

    /**
     * Equivalente a `handleResponse` para el mundo `HttpClient`: convierte un
     * `HttpErrorResponse` (HttpClient lanza en no-2xx) al MISMO objeto de error
     * `{ status:'error', code, message, response? }` que devuelve `handleResponse` (en 422 no hay `response`).
     * No lanza: se usa dentro del `catch` del wrapper para resolver con el objeto,
     * preservando el contrato que consumen servicios y componentes en su `.then()`.
     */
    handleHttpError(err: HttpErrorResponse) {
        const status = err && typeof err.status === 'number' ? err.status : 0;
        const obj = err && err.error && typeof err.error === 'object' ? err.error : {};

        if (status === 422) {
            let mssg = '';
            const arr = obj.message ? Object.keys(obj.message) : [];
            if (arr && arr.length) {
                arr.forEach(l => {
                    if (this.ErrorsMap[l]) {
                        if (this.ErrorsMap[l].message) {
                            mssg += ' ' + this.ErrorsMap[l].message;
                        } else if (this.ErrorsMap[l].messages) {
                            mssg += ' ' + this.ErrorsMap[l].messages[obj.message[l][0]];
                        }
                    } else {
                        mssg += ' ' + obj.message[l];
                    }
                });
            }
            return {
                message: mssg || obj.message,
                code: 422,
                status: 'error'
            };
        }

        const re: any = { ...this.ErrorsMap.generic };
        if (obj.message) {
            re.message = obj.message;
        }
        re.response = obj;
        re.code = +status;
        console.error('response from back (http): ', re);
        return re;
    }

}



